import { Injectable } from '@angular/core';
import { BaseRouteReuseStrategy, Route } from '@angular/router';

@Injectable()
export class SelectiveReuseStrategy extends BaseRouteReuseStrategy {
  override shouldDestroyInjector(route: Route): boolean {
    return !route.data?.['retainInjector'];
  }
}
